module.exports = __webpack_public_path__ + "img/arrow-top.345c5649.svg";